import { trackingConstants } from "../actions/constants/trackingConstants";

export const listTrackingSessionsReducer = (state = {}, action: any) => {
    switch (action.type) {
        case trackingConstants.listSessionsRequest:
            return { isLoading: true, isSuccess: false, isError: false };
        case trackingConstants.listSessionsSuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                sessions: action.payload.data || action.payload || [],
                totalCount: action.payload.totalCount || 0,
            };
        case trackingConstants.listSessionsFailure:
            return { isLoading: false, isSuccess: false, isError: true, error: action.payload };
        default:
            return state;
    }
};

export const viewTrackingSessionReducer = (state = {}, action: any) => {
    switch (action.type) {
        case trackingConstants.viewSessionRequest:
            return { isLoading: true, isSuccess: false, isError: false };
        case trackingConstants.viewSessionSuccess:
            return { isLoading: false, isSuccess: true, isError: false, session: action.payload };
        case trackingConstants.viewSessionFailure:
            return { isLoading: false, isSuccess: false, isError: true, error: action.payload };
        default:
            return state;
    }
};

export const activeTrackingSessionsReducer = (state = {}, action: any) => {
    switch (action.type) {
        case trackingConstants.getActiveSessionsRequest:
            return { isLoading: true, isSuccess: false, isError: false };
        case trackingConstants.getActiveSessionsSuccess:
            return { isLoading: false, isSuccess: true, isError: false, sessions: action.payload || [] };
        case trackingConstants.getActiveSessionsFailure:
            return { isLoading: false, isSuccess: false, isError: true, error: action.payload };
        default:
            return state;
    }
};

export const batchTodaySessionReducer = (state = {}, action: any) => {
    switch (action.type) {
        case trackingConstants.getSessionByBatchTodayRequest:
            return { isLoading: true, isSuccess: false, isError: false };
        case trackingConstants.getSessionByBatchTodaySuccess:
            return { isLoading: false, isSuccess: true, isError: false, session: action.payload };
        case trackingConstants.getSessionByBatchTodayFailure:
            return { isLoading: false, isSuccess: false, isError: true, error: action.payload };
        case trackingConstants.getSessionByBatchTodayReset:
            return {};
        default:
            return state;
    }
};

export const historyListReducer = (state = {}, action: any) => {
    switch (action.type) {
        case trackingConstants.historyListRequest:
            return { isLoading: true, isSuccess: false, isError: false };
        case trackingConstants.historyListSuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                ...action.payload,
            };
        case trackingConstants.historyListFailure:
            return { isLoading: false, isSuccess: false, isError: true, error: action.payload };
        default:
            return state;
    }
};

export const viewSessionStudentsReducer = (state = {}, action: any) => {
    switch (action.type) {
        case trackingConstants.viewSessionStudentsRequest:
            return { isLoading: true, isSuccess: false, isError: false };
        case trackingConstants.viewSessionStudentsSuccess:
            return { isLoading: false, isSuccess: true, isError: false, session: action.payload };
        case trackingConstants.viewSessionStudentsFailure:
            return { isLoading: false, isSuccess: false, isError: true, error: action.payload };
        default:
            return state;
    }
};

export const generateShareTokenReducer = (state = {}, action: any) => {
    switch (action.type) {
        case trackingConstants.generateShareTokenRequest:
            return { isLoading: true, isSuccess: false, isError: false };
        case trackingConstants.generateShareTokenSuccess:
            return { isLoading: false, isSuccess: true, isError: false, token: action.payload?.token, expiresAt: action.payload?.expiresAt };
        case trackingConstants.generateShareTokenFailure:
            return { isLoading: false, isSuccess: false, isError: true, error: action.payload };
        case trackingConstants.generateShareTokenReset:
            return {};
        default:
            return state;
    }
};

export const disableShareReducer = (state = {}, action: any) => {
    switch (action.type) {
        case trackingConstants.disableShareRequest:
            return { isLoading: true, isSuccess: false, isError: false };
        case trackingConstants.disableShareSuccess:
            return { isLoading: false, isSuccess: true, isError: false };
        case trackingConstants.disableShareFailure:
            return { isLoading: false, isSuccess: false, isError: true, error: action.payload };
        case trackingConstants.disableShareReset:
            return {};
        default:
            return state;
    }
};

export const shareStatusReducer = (state = {}, action: any) => {
    switch (action.type) {
        case trackingConstants.getShareStatusRequest:
            return { isLoading: true, isSuccess: false, isError: false };
        case trackingConstants.getShareStatusSuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                isSharing: action.payload?.isSharing ?? false,
                token: action.payload?.token ?? null,
                expiresAt: action.payload?.expiresAt ?? null,
            };
        case trackingConstants.getShareStatusFailure:
            return { isLoading: false, isSuccess: false, isError: true, error: action.payload };
        case trackingConstants.getShareStatusReset:
            return {};
        default:
            return state;
    }
};
